export default "__VITE_ASSET__5m7Sl_0J__"